import React from "react";
import { useTranslation } from "react-i18next";
import DialogTitle from "@mui/material/DialogTitle";
import { SFStack } from "../grid";
import SFTypography from "../typography";
import SFIconButton from "../button/iconButton";
import { SFCloseIcon } from "../icons";

const FullSearchDialogTitle = ({ title, onClose }) => {
  const { t } = useTranslation();
  return (
    <DialogTitle id="customized-dialog-title">
      <SFStack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        height="100%"
      >
        <SFTypography variant="body2bold">{title}</SFTypography>
        <SFIconButton
          aria-label={t("components.dialog.closeButtonAriaLabel")}
          onClick={onClose}
        >
          <SFCloseIcon />
        </SFIconButton>
      </SFStack>
    </DialogTitle>
  );
};

export default FullSearchDialogTitle;
